// extracted by mini-css-extract-plugin
export default {"color-concrete":"#F2F2F2","colorConcrete":"#F2F2F2","taxonomyLinks":"_1HvHa","category":"gcu8r","categoryTitle":"_20uGn","linkList":"_254GQ"};